import * as React from 'react';

import type {ActivityUpdateInput, GetTeams_teams as Team} from 'nutshell-graphql-types';

import type {UpdateLocation} from '../../types';

import {NoteSection} from './note-section';

type Props = {
    activityId: string | null | undefined;
    handleUpdateActivity: (input: ActivityUpdateInput, location: UpdateLocation) => Promise<void>;
    quillDelta: string | null | undefined;
    teams: Team[] | null | undefined;
};

export function NoteSectionWrapper(props: Props) {
    const {activityId, handleUpdateActivity} = props;

    const handleSave = React.useCallback(
        (value: string) => {
            if (!activityId) {
                return Promise.resolve();
            }

            return handleUpdateActivity(
                {
                    activity: activityId,
                    logNote: value,
                },
                'internal-notes'
            );
        },
        [activityId, handleUpdateActivity]
    );

    return <NoteSection quillDelta={props.quillDelta} teams={props.teams} onChange={handleSave} />;
}
